import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { TextKey } from '@mews-commander/enums';
import { isEditing, getSelectedEntityId } from '../../../entityManagement/selectors';
import { stopEntityEditing } from '../../../entityManagement/actions';
import { editFloor } from '../../actions/floors';
import { getSelectedFloor } from '../../selectors/floors';
import floorFormFactory from './floorFormFactory';

const FloorEditFormHelper = floorFormFactory({ headerButtonTextKey: TextKey.EditFloor });

export default connect(
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    createStructuredSelector({
        opened: isEditing,
        id: getSelectedEntityId,
        initialValues: getSelectedFloor,
    }),
    // @ts-expect-error $TSFixMeError: Property 'scope' does not exist on type '{}'.
    (dispatch, { scope }) => ({
        onSubmit: (values: $TSFixMe) => {
            dispatch(editFloor(values));
            dispatch(stopEntityEditing(scope));
        },
        onClose: () => dispatch(stopEntityEditing(scope)),
    })
)(FloorEditFormHelper);
